import actions from "./action.js";
import getters from "./getter.js";
import mutations from "./mutation.js";

export default {
    namespaced: true,
    state() {
        return {
            allowedExtensions: [],
            maxFileSize: 5 * 1024 * 1024, // Default 5MB
            fileSizeType: [],
            maxFileCount: 1,
            selectedFiles: [],
            error: null,
            isSuccessful: false
        }
    },
    getters,
    actions,
    mutations
}

